export const getFallbackUrl = ({ channelLogoId = 0, alt, format = 'standard' } = {}) => (
    `https://www.sky.com/services/image-placeholder/${channelLogoId}/whiteworld${alt ? `/${alt}` : ''}/${format}`
);

export const getFallbackSrc = ({ fallbackUrl = getFallbackUrl(), size = 300 } = {}) => (
    `${fallbackUrl}/${size}`
);
